/* eslint semi:0 */
import { createElement } from '../../utils/dom'
import userStore from './userStore'
import { BaseStore } from './baseStore'
import { safeRequest } from '../../utils/mithril'
import { get } from '../../application/pageDataObject'
import { TYPES as TOOLBAR_TYPES } from '../actions/userToolbarActions'
import {
  TYPES as EMBED_CODE_TYPES,
  embedDataReceived,
  embedDataFailed,
} from '../actions/embedCodeModalActions'

let EMBED_CODE_API = `/posts/${get('post.id')}/embed_code`

let lazySingletonInstance = null

export default class EmbedCodeModalStore extends BaseStore {
  static getInstance() {
    if (!lazySingletonInstance) {
      lazySingletonInstance = EmbedCodeModalStore.create()
    }
    return lazySingletonInstance
  }

  constructor(options = {}) {
    super(options)
    this.fetchModalData()
  }

  routeAction(action) {
    let { type } = action
    let ACTIONS = EMBED_CODE_TYPES
    switch (type) {
      case ACTIONS.EMBED_DATA_RECEIVED:
        return this.onDataReceived(action.data)
      case ACTIONS.EMBED_DATA_FAILED:
        return this.onDataError()
      case ACTIONS.EMBED_CONFIGURATION_CHANGED:
        return this.onConfigurationChanged(action.configOption)
      case TOOLBAR_TYPES.FB_LOGIN:
        return (this.state.dataReady = false)
      case TOOLBAR_TYPES.EXISTING_USER_AUTHENTICATED:
        return this.fetchModalData()
      default:
        return this
    }
  }

  fetchModalData() {
    let timeStamp = userStore.partnerId ? Date.now() : 'notPartner'
    safeRequest({
      method: 'GET',
      url: EMBED_CODE_API,
      data: {
        ts: timeStamp,
      },
    }).then(embedDataReceived, embedDataFailed)
  }

  onDataReceived(data) {
    Object.assign(this.state, data)
    this.embedCodeElement = createElement('div')
    this.embedCodeElement.innerHTML = data.embed_code
    this.state.dataReady = true
    this.emitChange()
  }

  onDataError() {
    this.state.dataError = true
    this.emitChange()
  }

  onConfigurationChanged(configOption) {
    let newValue = !this.state.configuration[configOption]
    this.state.configuration[configOption] = newValue
    let elementAction = newValue ? 'setAttribute' : 'removeAttribute'
    this.embedCodeElement.children[0][elementAction](`data-${configOption}`, '')
    this.emitChange()
  }

  get embedCodePretty() {
    let str = this.embedCodeElement.innerHTML
    return str.replace(/=\"\"/g, '')
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/stores/embedCodeModalStore.js